import FloatingMenuItem from '../../atoms/container/floatingMenuItem';
import FloatingMenuText from '../../atoms/text/floatingMenuText';
import ListContext from '../../../../shared/components/utils/context/listContext';
import FloatingIconContainer from '../../atoms/container/floatingIconContainer';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { FloatingMenuButtonProps as Props } from '../../../../shared/types/props/floatingMenu';
import { useContext } from 'react';

function FloatingMenuButton({
  clickAction,
  icon,
  children,
  index,
  text,
}: Props) {
  const { listIndex, setListIndex } = useContext(ListContext);
  const focused = listIndex === index || (listIndex === -1 && index === 0);
  const Icon = icon;

  return (
    <FloatingMenuItem
      focused={focused}
      onMouseEnter={() => {
        setListIndex(index);
      }}
      onPointerUp={clickAction}
    >
      <FloatingIconContainer>
        {Icon ? <Icon focused={focused} /> : null}
      </FloatingIconContainer>
      <FloatingMenuText>{TranslationManager.get(text)}</FloatingMenuText>
      {children}
    </FloatingMenuItem>
  );
}

export default FloatingMenuButton;
